import React, { useEffect, useRef, useState } from "react";
import { Box, Typography } from "@mui/material";

const ExpandableText = ({
  text,
  lines = 6,
  fontSize = { xs: "0.9rem", sm: "0.93rem" },
}) => {
  const textRef = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      const element = textRef.current;
      if (!element) return;

      setIsOverflowing(element.scrollHeight > element.clientHeight + 1);
    };

    checkOverflow();
    window.addEventListener("resize", checkOverflow);

    return () => {
      window.removeEventListener("resize", checkOverflow);
    };
  }, [text, lines]);

  return (
    <Box>
      <Typography
        ref={textRef}
        sx={{
          color: "#3f3f3f",
          fontSize,
          lineHeight: 1.8,
          textAlign: {
            xs: "left",
            sm: "justify",
          },
          whiteSpace: "pre-line",
          overflowWrap: "anywhere",

          // reserve equal height for six lines
          minHeight: {
            xs: "9.7rem",
            sm: "10.05rem",
          },

          ...(!expanded && {
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: lines,
            overflow: "hidden",
          }),
        }}
      >
        {text}
      </Typography>

      <Box
        sx={{
          minHeight: "1.9rem",
          mt: 0.8,
        }}
      >
        {isOverflowing && (
          <Typography
            component="button"
            type="button"
            onClick={() => setExpanded((prev) => !prev)}
            sx={{
              p: 0,
              border: 0,
              background: "none",
              color: "#9a6700",
              fontWeight: 700,
              fontSize: "0.82rem",
              cursor: "pointer",
              fontFamily: "inherit",
              "&:hover": {
                textDecoration: "underline",
              },
            }}
          >
            {expanded ? "Show less" : "Read more"}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default ExpandableText;
